// extracted by mini-css-extract-plugin
export default {"body":"settings_body__h1Qmz","list":"settings_list__MBcme"};